import { Button, Flex, Row, Space } from "antd";
import { CardContainer } from "components/elements";
import ShiftsListTable from "components/table/ShiftsTable";
import AttendenceFilter from "features/attendance/components/AttendenceFilter";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import styles from "../styles/Attendance.module.css";

const Shifts = ({
  isLoading = false,
  pagination = {},
  shiftsList = [],
  onCreate = () => { },
  onStatus = () => { },
  onEdit = () => { },
  onChange = () => { },
  onDelete = () => { },
  onCancel = () => { },
  onSearch = () => { },
  onColor = () => { },
  onView = () => { },
}) => {
  const { roles } = useSelector((state) => state.company);
  const [useFilter, setUseFilter] = useState(false);
  const { t, i18n } = useTranslation();

  return (
    <Space className={styles.container} size={24} direction="vertical">
      <Row justify="end">
        <Space direction="horizontal" size={12}>
          <Button type="default" onClick={() => { setUseFilter(!useFilter) }} style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}>
            <Flex align="center" justify="center" gap={8}>
              <FilterIcon />
              <span style={{ color: "#667085" }}>{t('othersetting.filter')}</span>
            </Flex>
          </Button>
          {
            roles.includes("CREATE_CONFIGURATION|ATTENDANCE_SETTING|SHIFT") && <Button onClick={onCreate} style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}
              type="primary">
              <Flex align="center" justify="center" gap={8}>
                <CreateIcon />
                {t('.othersettingcreate-1')}
              </Flex>
            </Button>
          }

        </Space>
      </Row>
      {useFilter &&
        <CardContainer width="100%" height="fit-content">
          <AttendenceFilter
            onEdit={onEdit}
            dataFlag={"shift"}
            onCancel={onCancel}
            onChange={onChange}
            onSubmit={onSearch} />
        </CardContainer>

      }
      {/* <CardContainer width="100%" height="fit-content"> */}
      <ShiftsListTable
        onColor={onColor}
        isLoading={isLoading}
        pagination={{
          current: pagination.page,
          pageSize: pagination.size,
          total: pagination.total,
          onChange: (page, size) => onChange({ page, size }),
        }}
        dataSource={shiftsList}
        onStatus={onStatus}
        onEdit={onEdit}
        onDelete={onDelete}
        onView={onView}
      />
      {/* </CardContainer> */}
    </Space>
  );
};

export default Shifts;
